import React, { useState } from "react";
import { Box, Card, Select, ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import FormatPaintIcon from "@material-ui/icons/FormatPaint";
import NaturePeopleIcon from "@material-ui/icons/NaturePeople";
import SatelliteIcon from "@material-ui/icons/Satellite";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import { greenRoad } from "../util/svg/greenRoad";
const menuStyle = {
  position: "absolute",
  top: 200,
  left: 0,
  padding: "10px",
};

const valueToIconMap = (defaultMapBoxStyle) => {
  const table = {
    [defaultMapBoxStyle]: {
      icon: (
        <ListItemIcon style={{ color: "#aaf" }}>
          {" "}
          <LocationCityIcon />
        </ListItemIcon>
      ),
      text: "Default",
    },
    "mapbox/streets-v11": {
      icon: <ListItemIcon>{greenRoad}</ListItemIcon>,
      text: "Streets",
    },
    "mapbox/light-v10": {
      icon: (
        <ListItemIcon style={{ color: "#aaa" }}>
          <FormatPaintIcon />
        </ListItemIcon>
      ),
      text: "Light",
    },
    "mapbox/dark-v10": {
      icon: (
        <ListItemIcon style={{ color: "#111" }}>
          <FormatPaintIcon />
        </ListItemIcon>
      ),
      text: "Dark",
    },
    "mapbox/outdoors-v11": {
      icon: (
        <ListItemIcon style={{ color: "#0f0" }}>
          <NaturePeopleIcon />
        </ListItemIcon>
      ),
      text: "Outdoors",
    },
    "mapbox/satellite-v9": {
      icon: (
        <ListItemIcon style={{ color: "#f00" }}>
          <SatelliteIcon />
        </ListItemIcon>
      ),
      text: "Satellite",
    },
  };
  return table;
};

const getValueToIconMap = (selectedValue, defaultMapBoxStyle) => {
  return valueToIconMap(defaultMapBoxStyle)[selectedValue];
};

const renderGivenValueStyle = (selectedValue, defaultMapBoxStyle) => {
  return (
    <Box
      sx={{
        flexDirection: "row",
        display: "flex",
      }}
    >
      {getValueToIconMap(selectedValue, defaultMapBoxStyle).icon}
      <ListItemText primary={getValueToIconMap(selectedValue, defaultMapBoxStyle).text} />
    </Box>
  );
};

const createMenuItem = (key, value) => {
  return (
    <MenuItem key={key} value={key}>
      {value.icon}
      <ListItemText primary={value.text}></ListItemText>
    </MenuItem>
  );
};

const createAllMenuItems = (defaultMapBoxStyle) => {
  const allItems = Object.entries(valueToIconMap(defaultMapBoxStyle)).map(([key, value]) =>
    createMenuItem(key, value),
  );
  return allItems;
};

export const MapStyleSelectorTool = (mapSelect, setMapSelect, setMapStyle, defaultMapBoxStyle) => {
  // mapSelect = last two parts of the URL
  // mapStyle = full URL to download the style
  const [openSelect, setOpenSelect] = useState(false);
  return (
    <Box style={menuStyle}>
      <Card>
        <Select
          value={mapSelect}
          open={openSelect}
          onClose={() => setOpenSelect(false)}
          onOpen={() => setOpenSelect(true)}
          onChange={(e) => {
            const mapStyle = `mapbox://styles/${e.target.value}`;
            setMapStyle(mapStyle);
            setMapSelect(e.target.value);
          }}
          renderValue={(value) => renderGivenValueStyle(value, defaultMapBoxStyle)}
        >
          {createAllMenuItems(defaultMapBoxStyle)}
        </Select>
      </Card>
    </Box>
  );
};
